export interface ServiceType {
  id: string;
  name: string;
  description: string;
  duration: number;
  price: number;
}

export interface ServiceProvider {
  id: string;
  name: string;
  avatar?: string;
  specialties: string[];
  availability: string;
}

export interface ProviderData {
  name: string;
  availability: string;
  services: ServiceType[];
}

export interface BookingData {
  service?: ServiceType;
  date?: Date;
  time?: string;
  customerName?: string;
  customerEmail?: string;
  customerPhone?: string;
  paymentMethod?: string;
  selectedProvider?: ServiceProvider;
  specialRequests?: string;
  tipAmount?: number;
  // No-show protection fields
  stripeCustomerId?: string;
  paymentMethodId?: string;
  paymentIntentId?: string;
  paymentType?: 'card' | 'cash';
}

export interface WaitlistEntry {
  id: string;
  businessId: string;
  customerName: string;
  customerEmail: string;
  customerPhone?: string;
  serviceId: string;
  serviceName: string;
  preferredDate?: Date;
  preferredTime?: string;
  status: 'pending' | 'confirmed' | 'cancelled';
  paymentStatus: 'pending' | 'paid' | 'refunded';
  amount: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface WaitlistNotification {
  id: string;
  waitlistEntryId: string;
  type: 'provider_notification' | 'customer_confirmation' | 'customer_reminder';
  status: 'pending' | 'sent' | 'failed';
  message: string;
  createdAt: Date;
  sentAt?: Date;
} 
/** Generic cancellation policy shown on the booking page when the
    provider hasn't authored their own (business_profiles.cancellation_fee_policy). */
export const DEFAULT_CANCELLATION_POLICY =
  'Please cancel or reschedule at least 24 hours in advance. Late cancellations and no-shows may incur a fee charged to your card on file. By booking, you agree to this policy.';
